<template>
  <section v-if="data">
    <NuxtPage :page-key="route => route.fullPath" />
    <PagesEducationComponent :data="data" />
  </section>
  <SharedErrorComponent v-else-if="error" :error="error" />
</template>

<script lang="ts" setup>
useHead({
  htmlAttrs: { 'data-page-type': 'education' }
})

// 2
const i18nActiveIso = baseI18nGetActiveIso()

const { data, error } = await useAsyncData(() =>
  fetchQueryPath( queryEducationPage(i18nActiveIso) )
)

basePageSetHead(data)
</script>
